import React, {useRef} from 'react';
import {connect, DispatchProp} from "react-redux";
import ScrollContainer from "react-indiana-drag-scroll";
import {RootState} from "../../../../../reducers";
import {withTranslation} from "react-i18next";
import ScrollMenuTo from "../../../../utils/ScrollMenuTo";
import MenuScrollSpy from "../../../../utils/MenuScrollSpy";
import PromotionHelper from "../../../../services/Menu/services/Promotion/PromotionHelper";
import {getCartTotal} from "../../../../services/Cart/reducer";
import {ReactComponent as ArrowLeftSVG} from "../../../../../images/icons/arrow-left.svg";
import {ReactComponent as ArrowRightSVG} from "../../../../../images/icons/arrow-right.svg";


interface OwnProps {
    promotions: any[],
    categories: any[],
    menu_id: string
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuCategoryNavComponent = (props: Props) => {
    const targetRef = useRef<HTMLDivElement | null>(null);
    const scrollLeft = () => {
        if (targetRef.current) {
            targetRef.current.scrollLeft += 60;
        }
    };
    const scrollRight = () => {
        if (targetRef.current) {
            targetRef.current.scrollLeft -= 60;
        }
    };
    const cartTotal = props.cartTotal;
    let menuCategories = props.categories;
    let activePromotions = PromotionHelper.getActivePromotionsForCategory(props.promotions, cartTotal);
    return (
        <div className="container-fluid">
            <div className={"nav-categories-wrapper nav-scrolling-buttons-wrapper"}>
                <div className={"navigate-left"}>
                    <button className={"btn btn-default btn-icon"} onClick={scrollRight}>
                        <ArrowLeftSVG/>
                    </button>
                </div>
                <div className={"navigate-right"}>
                    <button className={"btn btn-default btn-icon"} onClick={scrollLeft}>
                        <ArrowRightSVG/>
                    </button>
                </div>
                <ScrollContainer innerRef={targetRef as any} className="nav-categories nav nav-tabs-top"
                                 hideScrollbars={false}>
                    <MenuScrollSpy value={props.menu_id}>
                        {activePromotions.map((promotion: any) =>
                            <li className="nav-item" key={'category-promotion-' + promotion.id}>
                                <ScrollMenuTo to={'category-promotion-' + promotion.id}>
                                    {promotion.name}
                                </ScrollMenuTo>
                            </li>
                        )}
                        {
                            menuCategories.map((category, i) =>
                                <li className="nav-item" key={category.id}>
                                    <ScrollMenuTo to={`category-${props.menu_id}-${category.id}`}>
                                        {category.name}
                                    </ScrollMenuTo>
                                </li>
                            )
                        }
                    </MenuScrollSpy>
                </ScrollContainer>
            </div>
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    cartTotal: getCartTotal(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuCategoryNavComponent));
